module.exports = __webpack_public_path__ + "img/sacco9.83d9f73a.png";